import { render, staticRenderFns } from "./RechargeCardToCardWalletResult.vue?vue&type=template&id=1cd20b8e&scoped=true&"
import script from "./RechargeCardToCardWalletResult.vue?vue&type=script&lang=js&"
export * from "./RechargeCardToCardWalletResult.vue?vue&type=script&lang=js&"
import style0 from "./RechargeCardToCardWalletResult.vue?vue&type=style&index=0&id=1cd20b8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd20b8e",
  null
  
)

export default component.exports